package space.stanton.labs

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.dom.svg.Circle
import com.varabyte.kobweb.compose.dom.svg.SVGFillType
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.forms.Button
import kotlinx.browser.document
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea
import space.stanton.components.theme.Palette
import space.stanton.components.widgets.NavScaffold

@Page("/pages/labs")
@Composable
fun LabsPage() {
    NavScaffold {

        var names: List<String> by remember { mutableStateOf(emptyList()) }

        Text("Enter some names")
        TextArea(attrs = {
            id("names_area")
            style {
                height(30.vh)
                width(30.vw)
            }
        })
        Button(onClick = {
            @Suppress("UNUSED_VARIABLE")
            val element = document.getElementById("names_area")
            val nameString = js("element[\"value\"]").toString()
            names = nameString.split("\n")
        }) {
            Text("Run!")
        }

        Column {
            Box(
                modifier = Modifier
                    .width(90.vw)
                    .height(60.vh)
                    .padding(5.cssRem)
                    .position(Position.Relative)
                    .background(Palette.FadedLightBlue)

            ) {
                Svg {
                    Circle {
                        stroke(Palette.Cream)
                        strokeDashArray(126,100)
                        strokeDashOffset(-15)
                        strokeWidth(50)
                        fill(SVGFillType.None)
                        cx(50)
                        cy(50)
                        r(25)
                    }
                }

                names.forEachIndexed { i, name ->
                    Box(
                        modifier = Modifier
                            .height(5.cssRem)
                            .width(5.cssRem)
                            .position(Position.Absolute)
                            .top((i * 4).cssRem)
                            .left((i * 6).cssRem)
                            .borderRadius(50.percent)
                            .boxShadow(
                                offsetY = 4.px,
                                color = Palette.MidnightBlue,
                                spreadRadius = 2.px
                            )
                            .background(Palette.Maroon)
                            .attrsModifier {
                                style {
                                    color(Palette.TotalWhite)
                                }
                            },
                        contentAlignment = Alignment.Center
                    ) {
                        Text(name)
                    }
                }
            }
        }
    }
}